import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { TekiMACacheViewModel } from './tekiMACacheViewModel';

export class TekiMACacheContainer extends MasterDataContainer<TekiMACacheViewModel> {
    constructor(models: Array<TekiMACacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
